import $ from 'jquery';

class AssetRenderer {

	static cdn() {
		return "https://s3-eu-west-1.amazonaws.com/poy-assets-data/";
	}	

	constructor(asset) {
		this.asset = asset;
	}

	render(container) {

		let img = $("<img />").addClass("img-thumbnail");
		$(img).attr("src", this.asset);

		$(container).html(img);
		
	}

}

export default AssetRenderer;
